<template>
  <div class="box">
    <div class="left-box">
      <div class="head-box">
        <h4>代码类型</h4>
        <div>
          <i
            class="el-icon-circle-plus-outline c-pointer"
            title="添加代码类型"
            @click="listNew"
          ></i>
          <i class="el-icon-edit pointer c-m-l-10" title="编辑代码类型" @click="listEdit"></i>
          <i class="el-icon-delete c-pointer c-m-l-10" title="删除代码类型" @click="listRemove"></i>
        </div>
      </div>
      <div class="left-content row">
        <div class="content-group">
          <div
            v-for="(item, i) in listFpi.data"
            :key="i"
            class="content-item c-flex c-flex-between"
            :class="listForm._id == item._id ? 'is-selected' : ''"
            @click="
              listForm = item;
              getTableData();
            "
          >
            <span>
              {{ item.order }}） {{ item.name }}
              <el-tooltip content="系统预置代码！" placement="right" v-if="item.createUser == '0'">
                <i class="el-icon-info" style="color:#909399"></i>
              </el-tooltip>
            </span>
            <span>{{ item.type }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="right-box">
      <div class="head-box">
        <h4>代码数据</h4>
        <div class="c-flex">
          <el-button type="primary" @click.native="tableNew">添加数据</el-button>
        </div>
      </div>
      <div class="content-box">
        <!-- 列表 -->
        <el-table
          ref="table"
          v-if="refresh"
          :indent="20"
          :data="tableFpi.data"
          style="width: 100%;"
          height="calc(100% - 10px)"
          row-key="_id"
          lazy
          :load="load"
          :tree-props="{ children: 'children', hasChildren: '_id' }"
          @select="rowSelect"
          @row-click="rowClick"
          @select-all="removeSelected"
          highlight-current-row
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="order" label="排序" width="150"></el-table-column>
          <el-table-column prop="type" label="类型" width="150"></el-table-column>
          <el-table-column prop="name" label="名称" width="150"></el-table-column>
          <el-table-column prop="value" label="值"></el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button @click.native.prevent="tableEdit(scope.row)" type="text">
                编辑
              </el-button>
              <el-button @click.native.prevent="tableRemove(scope.row)" type="text">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 代码类型 -->
        <el-dialog
          title="代码类型"
          :visible.sync="listDialog"
          :before-close="listCancel"
          :close-on-click-modal="false"
        >
          <el-form
            :model="listForm"
            :rules="this.$util.rules"
            ref="listForm"
            label-position="left"
            label-width="60px"
          >
            <el-form-item label="序号" prop="order">
              <el-input v-model.number="listForm.order"></el-input>
            </el-form-item>
            <el-form-item label="名称" prop="name">
              <el-input v-model="listForm.name"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-input
                v-model.number="listForm.type"
                :disabled="listForm._id ? true : false"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button size="small" type="primary" @click="listSave">确 定</el-button>
            <el-button size="small" @click="listCancel">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 代码数据 -->
        <el-dialog
          title="代码数据"
          :visible.sync="tableDialog"
          :before-close="tableCancel"
          :close-on-click-modal="false"
        >
          <el-form
            :model="tableForm"
            :rules="this.$util.rules"
            ref="tableForm"
            label-position="left"
            label-width="60px"
          >
            <el-form-item label="排序" prop="order">
              <el-input type="number" v-model="tableForm.order"></el-input>
            </el-form-item>
            <el-form-item label="名称" prop="name">
              <el-input v-model="tableForm.name"></el-input>
            </el-form-item>
            <el-form-item label="值" prop="value">
              <el-input v-model="tableForm.value"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button type="primary" @click="tableSave">确 定</el-button>
            <el-button @click="tableCancel">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'Code',
  data() {
    return {
      tenantId: '',
      refresh: true,
      listFpi: {},
      listForm: {},
      listDialog: false,
      tableFpi: {},
      tableForm: {},
      tableDialog: false,
      currentRow: {}
    };
  },
  mounted() {
    window.$this = this;
    this.listInit();
    this.tableInit();
    this.getListData();
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
  },
  methods: {
    listInit() {
      this.listDialog = false;
      this.listForm = {};
      this.tableInit();
      this.tableFpi = {};
      this.currentRow = {};
    },
    getListData() {
      var params = {
        _all: '1',
        'nin:state|integer#and': [-1]
      };
      this.osg.ajax('codeType/query.do', params, res => {
        this.listFpi = res;
      });
    },
    listNew() {
      this.listInit();
      this.listDialog = true;
    },
    listEdit() {
      if (!this.listForm._id) {
        this.osg.toast('请选择要编辑的项', 'warning');
        return;
      }
      this.listDialog = true;
    },
    listSave() {
      if (this.osg.validate('listForm')) {
        this.osg.ajax('codeType/upsert.do', this.listForm, res => {
          this.listInit();
          this.getListData();
          this.osg.toast('保存成功！');
        });
      }
    },
    listCancel() {
      this.listInit();
      this.getListData();
    },
    listRemove() {
      if (!this.listForm._id) {
        this.osg.toast('请选择要删除的项', 'warning');
        return;
      } else if (this.listForm.createUser == '0') {
        this.osg.toast('系统预置代码不允许删除', 'warning');
        return;
      }
      this.osg.confirm(`是否确认删除 ${this.listForm.name}`, () => {
        this.osg.ajax(`codeType/remove/${this.listForm._id}.do`, {}, res => {
          this.listInit();
          this.getListData();
        });
      });
    },

    tableInit() {
      this.tableDialog = false;
      this.tableForm = {};
    },
    getTableData() {
      if (!this.listForm._id) {
        return;
      }
      this.osg.ajax(
        'code/query.do',
        {
          parentId: this.listForm._id,
          'nin:state|integer#and': [-1],
          _all: '1'
        },
        res => {
          this.tableFpi = res;
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.doLayout();
              this.$forceUpdate();
            }
          });
          this.currentRow = {};
          this.Refresh();
        }
      );
    },
    tableNew() {
      if (!this.listForm._id) {
        this.osg.toast('请先选择代码类型！', 'warning');
        return;
      }
      this.tableInit();
      this.tableDialog = true;
    },
    tableEdit(row) {
      this.tableForm = row;
      this.tableDialog = true;
    },
    tableSave() {
      var params = this.tableForm;
      params.tenantId = this.tenantId;
      params.type = this.listForm.type;
      params.typeId = this.listForm._id;
      if (this.currentRow._id) {
        params.parentId = params.parentId || this.currentRow._id; //选中行，编辑或添加下级
      } else {
        params.parentId = this.listForm._id; //未选中行，添加1级
      }
      if (this.osg.validate('tableForm')) {
        this.osg.ajax('code/upsert.do', params, res => {
          this.tableInit();
          this.getTableData();
          this.osg.toast('保存成功！');
        });
      }
    },
    tableCancel() {
      this.tableInit();
      this.getTableData();
    },
    tableRemove(row) {
      this.osg.confirm(`是否确认删除 ${row.name}`, () => {
        this.osg.ajax(`code/remove/${row._id}.do`, {}, res => {
          this.getTableData();
        });
      });
    },
    rowSelect(rows) {
      this.$refs.table.clearSelection();
      if (rows.length > 0) {
        this.$refs.table.toggleRowSelection(rows[rows.length - 1], true);
        this.currentRow = rows[0];
      } else {
        this.currentRow = {};
      }
    },
    rowClick(row) {
      this.$refs.table.clearSelection();
      if (row._id == this.currentRow._id) {
        this.currentRow = {};
        return;
      }
      this.$refs.table.toggleRowSelection(row, true);
      this.currentRow = row;
    },
    removeSelected() {
      this.$refs.table.clearSelection();
      this.currentRow = {};
    },
    load(tree, treeNode, resolve) {
      this.osg.ajax(
        'code/query.do',
        {
          parentId: tree._id,
          page: 1,
          rows: 100,
          'nin:state|integer#and': [-1]
        },
        res => {
          resolve(res.data);
        }
      );
    },
    //表格刷新
    Refresh() {
      this.refresh = false;
      this.$nextTick(function() {
        this.refresh = true;
      });
    }
  }
};
</script>
